export class SetNotebookProducts {
    public static readonly type = "[Projects] Set notebook products";

    constructor(public payload: number) {}
}
